var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card-last',{attrs:{"title":"Whoop Whoop!"}},[_c('p',[_vm._v("Here’s a trophy for ordering the steps to effective condom use! Keep going to collect more!")])])}
var staticRenderFns = []

export { render, staticRenderFns }